import React, { FC, useMemo } from 'react'
import { CMSStaticSection } from '../../../models'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { JCMSStaticCard } from '../JCMSStaticCard'
import { JSlider } from '../../../JSlider'
import { JCMSStaticBanner } from '../JCMSStaticBanner'
import { SLIDER_1X, SLIDER_3X, getSliderConfig } from '../../../JSlider'


export interface JCMSStaticSliderProps extends CMSStaticSection.Slider { }

export const JCMSStaticSlider: FC<JCMSStaticSliderProps> = props => {
    if (!props.enabled) return <></>
    
    
    const config = useMemo(()=> {
        if(
            !props.options?.slideToShow && 
            (props.sections.every(s => CMSStaticSection.isBanner(s)))
        ) {
            return (props.sections.every(s => CMSStaticSection.isBanner(s))) ? SLIDER_1X : SLIDER_3X
        }
        return getSliderConfig({
            slidesToShow: props.options?.slideToShow || 4,
            infinite: !props.options?.disableInfiniteLoop,
        }, undefined, {
            arrows: props.options?.showAlwaysArrow ? true : undefined,
            infinite: !props.options?.disableInfiniteLoop,
        })

    }, [props])
    return (
        <JSlider {...config}>
            {
                props.sections
                    .filter(s => (CMSStaticSection.isBanner(s) || CMSStaticSection.isCard(s)) && s.enabled)
                    .map((section, i) => {                    
                    if(CMSStaticSection.isBanner(section)) {
                        return <JCMSStaticBanner {...section} key={i}/>
                    } else if(CMSStaticSection.isCard(section)) {
                        return <JCMSStaticCard {...section} key={i}/>
                    }
                    return <div></div>
                })
            }
        </JSlider>
    )
}